export default __webpack_public_path__ + "static/media/Vambraces of the Crimson Fort.6960685d.jpg";